<template>
  <div class="container">
    <top :title="title"></top>

    <div class="infos">
      <!-- 订单基本信息卡片 -->
      <div class="info-card basic-info">
        <div class="card-header">
          <div class="order-no">
            订单号：<span>{{ goodObj.orderNumber }}</span>
          </div>
          <div class="style-no">
            款号：<span>{{ goodObj.styleCode }}</span>
          </div>
        </div>

        <div class="card-body">
          <!-- 图片预览 -->
          <div class="img-section">
            <!-- <div class="section-title">图片预览</div> -->
            <div >
              <!-- <img class="good-img" :src="goodObj.img" alt="产品图片" /> -->
              <image-preview v-for="(img,index) in imgs" :key="index" :src="img" :width="120" :height="120" />
            </div>
          </div>

          <!-- 订单数量 -->
          <div class="order-quantity">
            <div class="section-title">订单数量</div>
            <div class="quantity-grid">
              <div
                class="size-item"
                v-for="(item, index) in orderNum.detailList"
                :key="index"
              >
                <div class="size-label">{{ item.sizeValue }}</div>
                <div class="size-value">{{ item.number }}</div>
              </div>
            </div>
            <div class="remark">备注：{{ goodObj.remark }}</div>
          </div>
        </div>
      </div>

      <!-- 动态添加的加工项目 -->
      <div
        class="info-card process-card"
        v-for="(item, index) in laserlist"
        :key="index"
      >
        <div class="card-header">
          <div class="card-title">{{ item.createName }}</div>
          <i
            class="el-icon-remove remove-icon"
            @click="removeItem(index)"
            v-if="laserlist.length > 1 && !item.createName"
          ></i>
        </div>

        <div class="card-body">
          <!-- 工序信息 -->
          <div class="form-grid">
            <div class="form-group">
              <label class="form-label">工序名称</label>
              <el-input
                v-model="item.name"
                size="small"
                placeholder="请输入工序名称"
                class="form-input"
                :disabled="!item.edit"
              ></el-input>
            </div>

            <div class="form-group">
              <label class="form-label">工序单价</label>
              <el-input
                v-model="item.price"
                size="small"
                placeholder="0.00"
                class="form-input"
                type="number"
                :disabled="!item.edit"
              >
                <template slot="append">元</template>
              </el-input>
            </div>

            <div class="size-inputs">
              <div
                class="size-input-group"
                v-for="(obj, index3) in item.detailList"
                :key="index3"
              >
                <label class="size-label">{{ obj.sizeValue }}</label>
                <el-input
                  v-model="obj.number"
                  size="small"
                  placeholder="0"
                  class="size-input"
                  type="number"
                  :disabled="!item.edit"
                ></el-input>
              </div>
            </div>

            <div class="form-group full-width">
              <label class="form-label">备注</label>
              <el-input
                class="remark-input"
                type="textarea"
                :rows="2"
                placeholder="请输入备注内容"
                v-model="item.remark"
                resize="none"
                :disabled="!item.edit"
              ></el-input>
            </div>
          </div>
        </div>
      </div>

      <!-- 添加新项目按钮 -->
      <div class="add-card" @click="add">
        <i class="el-icon-circle-plus-outline"></i>
        <div class="add-text">添加加工项目</div>
      </div>

      <!-- 提交按钮 -->
      <div class="action-bar">
        <el-button class="submit-btn" type="primary" @click="submit"
          >提交数据</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import { getClothingInfo, saveClothing } from "@/http/index";

export default {
  components: { top },
  data() {
    return {
      id: "",
      orderId: "",
      title: "车位加工",
      imgLoaded: false,
      laserlist: [],
      imgs: [],
      goodObj: {},
      orderNum: {},
      sizeList: [],
    };
  },
  watch: {
    laserlist: {
      deep: true, // 深度监听
      immediate: true, // 立即执行一次
      handler(val) {
        if (val) {
          val.map((item) => {
            item.number = item.detailList.reduce(
              (sum, detail) => sum + (Number(detail?.number) || 0),
              0
            );
          });
        }
      },
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.orderId = this.$route.query.orderId;
    this.getInfo();
  },
  methods: {
    getInfo() {
      getClothingInfo(this.orderId).then((res) => {
        this.goodObj = res.data;
        if (this.goodObj && this.goodObj.img) {
          this.imgs = this.goodObj.img.split(",");
        }
        this.orderNum = res.data.processList[0];
        this.laserlist = res.data.processList.slice(1);
        this.sizeList = [];
        this.orderNum.detailList.map((item) => {
          this.sizeList.push({
            sizeValue: item.sizeValue,
            number: 0,
          });
        });
        console.log(this.orderNum, this.laserlist, "----");
      });
    },
    add() {
      this.laserlist.push({
        createName: "",
        edit: true,
        number: 0,
        assignId: this.orderId,
        remark: "",
        detailList: this.sizeList,
        name: "",
        price: "",
      });
      // 滚动到新添加的项目
      setTimeout(() => {
        const elements = document.querySelectorAll(".process-card");
        if (elements.length > 0) {
          elements[elements.length - 1].scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    },
    removeItem(index) {
      if (this.laserlist.length > 1) {
        this.laserlist.splice(index, 1);
      }
    },
    submit() {
      // 提交逻辑
      console.log(this.laserlist, "---");
      saveClothing(this.laserlist).then((res) => {
        if (res.code == 200) {
          this.$message.success("保存成功");
          this.getInfo();
        }
        console.log(res, "------");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #f5f7fa;
}

.infos {
  padding: 16px;
  padding-bottom: 80px; /* 为底部按钮留空间 */
}

/* 卡片通用样式 */
.info-card {
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 16px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;

  &:active {
    transform: translateY(2px);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  }
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  background: linear-gradient(135deg, #f8f9fa 0%, #f1f3f5 100%);
  border-bottom: 1px solid #eef0f3;

  .order-no,
  .style-no {
    font-size: 14px;
    color: #606266;

    span {
      font-weight: 600;
      color: #303133;
    }
  }

  .card-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }
}

.card-body {
  padding: 16px;
}

/* 基础信息卡片 */
.basic-info {
  .card-header {
    .add-icon {
      font-size: 22px;
      color: #e24a41;
      padding: 6px;
      border-radius: 50%;
      background: white;
      box-shadow: 0 2px 6px rgba(226, 74, 65, 0.2);
    }
  }

  .img-section {
    margin-bottom: 20px;

    .section-title {
      font-size: 15px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 12px;
    }

    .img-preview {
      position: relative;
      width: 120px;
      height: 120px;
      border-radius: 8px;
      overflow: hidden;
      background: #f5f7fa;

      .good-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .img-placeholder {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        color: #909399;

        .el-icon-picture-outline {
          font-size: 32px;
          margin-bottom: 8px;
        }
      }
    }
  }

  .order-quantity {
    .quantity-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(70px, 1fr)); /* 自动适应 */
        gap: 8px;
        margin-bottom: 16px;

        .size-item {
          text-align: center;
          padding: 10px 4px;
          background: #f8f9fa;
          border-radius: 8px;

          .size-label {
            font-size: 13px; /* 更小的字体 */
            color: #909399;
            margin-bottom: 4px;
          }

          .size-value {
            font-size: 14px;
            font-weight: 700;
            color: #e24a41;
          }
        }
    }

    .remark {
      font-size: 14px;
      color: #606266;
      line-height: 1.5;
      padding: 12px;
      background: #f8f9fa;
      border-radius: 8px;
      word-break: break-word;
    }
  }
}

/* 加工项目卡片 */
.process-card {
  .card-header {
    .remove-icon {
      font-size: 18px;
      color: #f56c6c;
      padding: 6px;
      border-radius: 50%;
      background: white;
      box-shadow: 0 2px 6px rgba(245, 108, 108, 0.2);
    }
  }

  .form-grid {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .form-group {
      &.full-width {
        width: 100%;
      }

      .form-label {
        display: block;
        font-size: 14px;
        font-weight: 500;
        color: #303133;
        margin-bottom: 8px;
      }

      .form-input {
        width: 100%;

        ::v-deep .el-input__inner {
          border-radius: 8px;
        }
      }
    }

    .size-inputs {
      display: flex;
      width: 100%;
      gap: 12px;
      flex-wrap: wrap;

      .size-input-group {
        width: 30%;

        .size-label {
          display: block;
          font-size: 13px;
          color: #606266;
          margin-bottom: 6px;
          text-align: center;
        }

        .size-input {
          width: 100%;

          ::v-deep .el-input__inner {
            text-align: center;
            border-radius: 8px;
          }
        }
      }
    }

    .remark-input {
      ::v-deep .el-textarea__inner {
        border-radius: 8px;
        font-size: 14px;
      }
    }
  }
}

/* 添加卡片按钮 */
.add-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px 16px;
  background: #ffffff;
  border-radius: 12px;
  border: 2px dashed #dcdfe6;
  margin-bottom: 16px;
  color: #909399;
  transition: all 0.3s ease;

  &:active {
    background: #f8f9fa;
    border-color: #c0c4cc;
  }

  .el-icon-circle-plus-outline {
    font-size: 32px;
    margin-bottom: 8px;
  }

  .add-text {
    font-size: 15px;
    font-weight: 500;
  }
}

/* 底部操作栏 */
.action-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background: #ffffff;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);
  z-index: 100;

  .submit-btn {
    width: 100%;
    height: 48px;
    border-radius: 24px;
    font-size: 16px;
    font-weight: 600;
    background: #e24a41;
    border: none;

    ::v-deep & {
      .el-button {
        width: 100%;
      }
    }
  }
}

/* 响应式调整 */

/* 动画效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
